import PaginaPrincipal from "./PaginaPrincipal";
export default PaginaPrincipal;